import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';

import { Spinner } from '~ui-kit';

const Linkset = props => {
  const { options } = props;
  const location = useLocation();

  return (
    <Container>
      <Intro>Siirry tekemään tilaus ulkoisen linkin kautta:</Intro>
      {options?.map(option => (
        <LinkContainer key={option.value}>
          <ExternalLink
            to="/linkkimodaali"
            state={{
              previousLocation: location,
              externalUrl: option.value,
            }}
          >
            <ExternalIcon icon={faExternalLinkAlt} />
            <Label>{option.label}</Label>
          </ExternalLink>

          <Description>{option.tooltip}</Description>
        </LinkContainer>
      )) || <Spinner />}
    </Container>
  );
};

const Container = styled.div`
  & > :last-child {
    border-bottom: 1px solid #cccccc;
  }
`;

const Intro = styled.div`
  color: var(--blue);
  margin-bottom: 12px;
`;

const LinkContainer = styled.div`
  border-top: 1px solid #cccccc;
  padding-top: 18px;
  padding-bottom: 18px;
`;

const ExternalLink = styled(Link)`
  display: flex;
  align-items: center;
  color: var(--green);
  cursor: pointer;
`;

const ExternalIcon = styled(FontAwesomeIcon)`
  margin-right: 12px;
`;

const Label = styled.div`
  font-weight: 600;
`;

const Description = styled.div`
  margin-top: 12px;
`;

export default Linkset;
